export default __webpack_public_path__ + "static/media/Phone.b93452f9.png";